import React from 'react';
import { createRoot } from 'react-dom/client';
import NewsCatalog from './components/NewsCatalog';

const container = document.getElementById('news-catalog');
if (container) {
  const root = createRoot(container);
  root.render(<NewsCatalog />);
}
